import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router';
import './styles/base.css';
import { Shell } from './routes/shell';
import { Login } from './routes/login';
import { Home } from './routes/home';
import { Narrative } from './routes/narrative';
import { ReportPage } from './routes/report';
import { Activity } from './routes/activity';
import { System } from './routes/system';

const root = createRootRoute({ component: () => <Outlet /> });
const login = createRoute({ getParentRoute: () => root, path: '/login', component: Login });
const shell = createRoute({ getParentRoute: () => root, id: 'shell', component: Shell });
const home = createRoute({ getParentRoute: () => shell, path: '/', component: Home });
const narrative = createRoute({ getParentRoute: () => shell, path: '/n/$slug', component: Narrative, validateSearch: (s: Record<string, unknown>) => ({ tab: typeof s['tab'] === 'string' ? (s['tab']) : undefined }) });
const report = createRoute({ getParentRoute: () => shell, path: '/n/$slug/report/$id', component: ReportPage });
const activity = createRoute({ getParentRoute: () => shell, path: '/activity', component: Activity });
const system = createRoute({ getParentRoute: () => shell, path: '/system', component: System });
const routeTree = root.addChildren([login, shell.addChildren([home, narrative, report, activity, system])]);
const router = createRouter({ routeTree, defaultPreload: 'intent' });
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 5_000 } } });

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
